import { render, staticRenderFns } from "./Wizard.vue?vue&type=template&id=a84d0d18&scoped=true"
import script from "./Wizard.vue?vue&type=script&lang=ts"
export * from "./Wizard.vue?vue&type=script&lang=ts"
import style0 from "./Wizard.vue?vue&type=style&index=0&id=a84d0d18&prod&lang=scss&scoped=true"
import style1 from "./Wizard.vue?vue&type=style&index=1&id=a84d0d18&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a84d0d18",
  null
  
)

export default component.exports